<template>
  <div class="card bg-white border-0 rounded-3 mb-4">
    <div class="card-body p-4">
      <h3 class="mb-3 mb-lg-4">About This Event</h3>
      <p>
        Pellentesque viverra lorem malesuada nunc tristique sapien. Imperdiet
        sit hendrerit tincidunt bibendum donec adipiscing. Tellus non morbi
        nascetur cursus etiam facilisis mi. Dolor aliquam sed amet aliquam
        venenatis. Ac viverra interdum tortor enim. Molestie tincidunt ut
        consequat a urna tortor. Vitae velit ac nisl velit mauris.
      </p>
      <p>
        Imperdiet sit hendrerit tincidunt bibendum donec adipiscing. Tellus non
        morbi nascetur cursus etiam facilisis mi. Dolor aliquam sed amet aliquam
        venenatis. Ac viverra interdum tortor enim. Molestie tincidunt ut.
      </p>
      <ul class="text-primary mb-0 pt-2">
        <li class="mb-2 pb-1">
          <span class="text-body">
            Pellentesque viverra lorem malesuada nunc tristique sapien.
          </span>
        </li>
        <li class="mb-2 pb-1">
          <span class="text-body">
            Imperdiet sit hendrerit tincidunt bibendum donec adipiscing.
          </span>
        </li>
        <li class="mb-2 pb-1">
          <span class="text-body">
            Tellus non morbi nascetur cursus etiam facilisis mi.
          </span>
        </li>
        <li class="mb-0">
          <span class="text-body">
            Imperdiet sit hendrerit tincidunt bibendum donec adipiscing.
          </span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "AboutThisEvent",
});
</script>
